import { BrowserRouter } from "react-router-dom";
import { SignedInRoutes } from "./signedIn";
import useAuthStore from "@repo/core/stores/auth";
import { SignedOutRoutes } from "./signedOut";

export const AppRoutes = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return (
    <BrowserRouter>
      {isAuthenticated ? <SignedInRoutes /> : <SignedOutRoutes />}
    </BrowserRouter>
  );
};
